import {
  Alert,
  CardActions,
  CardHeader,
  Divider,
  Grid,
  Paper,
  Stack,
} from "@mui/material";
import { useEffect, useState } from "react";
import AppButton from "../../shares/AppButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { DeleteOutline, EditOutlined, InfoOutlined } from "@material-ui/icons";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import AutreCompetenceForm from "./forms/AutreCompetenceForm";
import { useQuery } from "../../../../hooks/useQuery";
import { CVService } from "../../../../service/CVService";
import useConfirm from "../../../../hooks/useConfirm";
import useToast from "../../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";

const AutreCompetence = () => {
  const [autreCompetences, setAutreCompetences] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const query = useQuery();
  const id_identite = query.get("id_identite");
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { Toast, showToast } = useToast();

  const handleCloseEducationForn = () => {
    setFormOpen(false);
    handleFetchAutreCompetences();
  };

  const handleOpenEducationFormDialog = (education) => {
    setSelectedId(null);
    setFormOpen(true);
  };

  const handleUpdateAutreCompetence = (competence) => {
    setSelectedId(competence);
    setFormOpen(true);
  };

  const confirmDelete = (autreCompetence) => {
    CVService.deleteAutreCompetence(autreCompetence.id_competence).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchAutreCompetences({
          id_identite: id_identite,
        });
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleDeleteAutreCompetence = (autreCompetence) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => confirmDelete(autreCompetence)
    );
  };

  const handleFetchAutreCompetences = () => {
    CVService.getautreCompetenceList({
      id_identity: id_identite,
    }).then((res) => {
      if (res && res.data) {
        setAutreCompetences(res.data);
      }
    });
  };

  useEffect(() => {
    handleFetchAutreCompetences();
  }, []);

  return (
    <>
      <DialogComponent />
      <Toast />
      <AutreCompetenceForm
        open={formOpen}
        onFormClose={handleCloseEducationForn}
        idAutreCompetence={selectedId}
      />
      <Paper>
        <Grid item xs={12} width={"100%"}>
          <CardHeader
            sx={{ m: 2 }}
            title="Langues et autres competences"
            action={
              <Grid>
                <AppButton
                  icon={<AddCircleOutlineOutlinedIcon />}
                  text={"Ajouter"}
                  onClick={handleOpenEducationFormDialog}
                  variant={"outlined"}
                />
              </Grid>
            }
          />
          {autreCompetences.length > 0 ? (
            autreCompetences.map((item, index) => (
              <Grid key={index}>
                <ul>
                  <CardHeader
                    title={
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <li style={{ fontSize: "20px" }}>{`${item.type}`}</li>
                      </Stack>
                    }
                    subheader={
                      <Grid>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <AccountTreeOutlinedIcon />
                          <span>{`Type : ${item.competence || ""}`}</span>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <TrendingUpOutlinedIcon />
                          <span>
                            <span>{`Capacité : ${item.niveau || ""}`}</span>
                          </span>
                        </Stack>
                      </Grid>
                    }
                  />
                  <CardActions sx={{ justifyContent: "flex-end", mr: 2 }}>
                    <AppButton
                      icon={<EditOutlined />}
                      onClick={(e) =>
                        handleUpdateAutreCompetence(item.id_competence)
                      }
                      text={"Modifier"}
                      variant={"outlined"}
                    />
                    <AppButton
                      icon={<DeleteOutline />}
                      onClick={e=>handleDeleteAutreCompetence(item)}
                      text={"Supprimer"}
                      color={"warning"}
                      variant={"outlined"}
                    />
                  </CardActions>
                </ul>
                <Divider variant="middle" />
              </Grid>
            ))
          ) : (
            <Grid item p={3}>
              <Alert variant="outlined" color="info" icon={<InfoOutlined />}>
                Aucune information
              </Alert>
            </Grid>
          )}
        </Grid>
      </Paper>
    </>
  );
};

export default AutreCompetence;
